import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from '../services/authService';
import {
  showSuccessAlert,
  showErrorAlert,
} from "../services/alertService";
import "./FormStyles.css";

const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        const data = await login(email, password);
        if (data.error){
          //console.error('Login failed', data.error);
          // Manejar error de login
          showErrorAlert("Usuario o contraseña incorrectos");
          return;
        }
        if (data.token){
          localStorage.setItem('token', data.token);
          navigate('/admin');
        }
      } catch (error) {
        console.error('Login failed', error);
        showErrorAlert("Usuario o contraseña incorrectos");
        // Manejar error de login
      }
  };

  return (
    <div className="form-container">
      <form onSubmit={handleSubmit} className="form-content text-center">
        <h3>Login</h3>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">
            Email
          </label>
          <input
            type="email"
            className="form-control text-center"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="password" className="form-label">
            Password
          </label>
          <input
            type="password"
            className="form-control text-center"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button type="submit" className="btn btn-primary ">
          Login
        </button>
      </form>
    </div>
  );
};

export default LoginForm;
